import React from 'react';
import { Alert } from '@mui/material';
import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

interface AlertMessageProps {
  messageText?: Field<string>;
}

const AlertMessage: React.FC<AlertMessageProps> = ({ messageText }) => {
  if (!messageText?.value) {
    return null;
  }

  return (
    <Alert severity="info">
      <Text field={messageText} />
    </Alert>
  );
};

export default AlertMessage;
